















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { InternalSite, SiteRole, siteAdminRoleApis, roleType, adminType } from '../../api';
import RoleEditDialog from './RoleEditDialog.vue';
import RoleMembersDialog from './RoleMembersDialog.vue';

@Component({ components: { RoleEditDialog, RoleMembersDialog } })
export default class SiteRolesTable extends Vue {
  @Prop() siteId!: number;
  @Prop() tabValue!: string;
  @Ref('role-edit-dialog') roleEditDialog!: RoleEditDialog;
  @Ref('role-members-dialog') roleMembersDialog!: RoleMembersDialog;

  roles: Array<SiteRole> = [];
  loading = false;
  watchParams() {
    return [this.siteId, this.tabValue];
  }

  async mounted() {
    this.$watch(this.watchParams, this.refreshRoles);
    await this.refreshRoles();
  }

  async refreshRoles() {
    if (this.tabValue == 'perm_role') {
      this.loading = true;
      this.roles = [];
      try {
        this.roles = await siteAdminRoleApis.getRoles(this.siteId, roleType[this.tabValue]);
      } finally {
        this.loading = false;
      }
    }
  }

  async createRole() {
    const role = await this.roleEditDialog.show(null);
    this.roles.push(role);
    this.$notify.success(`添加角色[${role.title}]成功`);
  }

  async editRole(role: SiteRole) {
    const newRole = await this.roleEditDialog.show(role);
    const idx = this.roles.findIndex(r => r.id === newRole.id);
    if (idx >= 0) {
      Vue.set(this.roles, idx, newRole);
    }
    this.$notify.success(`保存角色[${newRole.title}]成功`);
  }

  async deleteRole(role: SiteRole) {
    await siteAdminRoleApis.deleteRole(this.siteId, role.id);
    const idx = this.roles.findIndex(r => r.id === role.id);
    if (idx >= 0) {
      this.roles.splice(idx, 1);
    }
    this.$notify.success(`删除角色[${role.title}]成功`);
  }

  showRoleMembers(role: SiteRole) {
    let type = '';
    if (this.getPerm('Authorizer')) {
      type = 'Authorizer';
    }
    this.roleMembersDialog.show(role, type);
  }

  get site(): InternalSite {
    return this.$store.getters['sites/getSite'](this.siteId);
  }

  getPerm(type: string) {
    const perm = adminType[type];
    return this.site.perms.indexOf(perm) > -1;
  }
}
